import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import withMatch from '@/hocs/withMatch';
import Link from '@/components/atoms/Link';
import { connect } from 'react-redux';
import { colorPalette, textStyles, fonts, fadeIn } from '../../styles/styleGuide';
import { toBreakpoint } from '../../styles/breakpoints';
import { performApiRequest, invalidateApiDataRequest, getResultData, getApiDataRequest } from '../../redux/apiData';
import FormGenerator from '../shared/forms/FormGenerator';
import { openModal } from '../../redux/modal';
import getFormCJ1, { ARTICLE_NOTIFICATIONS, PROJECT_UPDATE_NOTIFICATIONS } from './utils/getProfileFormDefinitionCJ1';
import getFormCJ2 from './utils/getProfileFormDefinitionCJ2';
import isObjectEmpty from '../../services/isObjectEmpty';
import flatMap from 'lodash.flatmap';
import get from 'lodash.get';
import Button from '@/atoms/Button';
import ButtonPrimary from '@/components/shared/buttons/ButtonPrimary';
import Box from '@/atoms/Box';
import { StaticPageSlugForProject } from '@/types/pageType';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  projectSlug = String(projectSlug);
  env = String(env);
  return {
    phase: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: projectSlug,
      env: env
    }), 'phase', undefined),
    profile: getResultData(state.apiData, 'getProfile', {
      projectSlug: projectSlug
    }),
    getRequest: getApiDataRequest(state.apiData, 'getProfile', {
      projectSlug: projectSlug
    }),
    patchRequest: getApiDataRequest(state.apiData, 'patchProfile', {
      projectSlug: projectSlug
    }),
    resultProfile: getResultData(state.apiData, 'patchProfile', {
      projectSlug: projectSlug
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getProfile: function getProfile() {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch(performApiRequest('getProfile', {
        projectSlug: String(projectSlug)
      }));
    },
    invalidateProfile: function invalidateProfile() {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch(invalidateApiDataRequest('getProfile', {
        projectSlug: String(projectSlug)
      }));
    },
    displaySuccessModal: function displaySuccessModal(changedValues) {
      dispatch(openModal(colorPalette.lightOrange, changedValues));
    },
    updateProfile: function updateProfile(values) {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch(performApiRequest('patchProfile', {
        projectSlug: String(projectSlug)
      }, values));
    }
  };
};
var ProfileForm = /*#__PURE__*/function (_Component) {
  function ProfileForm() {
    var _this;
    _classCallCheck(this, ProfileForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProfileForm, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false,
      error: ''
    });
    /**
     * This method is used to return a numeric value when a boolean value is passed
     * The backend only accepts numeric values as a result for the input of
     * articleNotifications or projectUpdateNotifications
     *
     * @param value
     * @returns Numeric boolean value
     */
    _defineProperty(_this, "getNumericBooleanValue", function (value) {
      if (typeof value !== 'boolean') {
        return value;
      }
      if (value === true) {
        return 1;
      } else {
        return 0;
      }
    });
    _defineProperty(_this, "getFormValues", function (_ref) {
      var profile = _ref.profile,
        phase = _ref.phase,
        contactUrl = _ref.contactUrl;
      // We only get the values for the fields in props
      // that we defined in our formDefinitions.
      // That way we make sure we only fill the defaultValues
      // object with the fields we want.
      if (!profile) return {};
      var profileData = phase === 'cj1' ? profile : Object.assign({}, profile, profile.customer);
      var formCJ1WithValues = getFormCJ1(contactUrl, profile.email);
      return profileData ? flatMap(phase === 'cj1' ? formCJ1WithValues : profile.customer ? getFormCJ2(contactUrl, profile.customer).concat(formCJ1WithValues) : null, function (formCat) {
        return formCat.options;
      }).reduce(function (acc, curr) {
        acc[curr.name] = profileData[curr.name];
        return acc;
      }, {}) : {};
    });
    _defineProperty(_this, "handleSubmit", function (values) {
      _this.setState({
        loading: true
      }, function () {
        // Adjust boolean values if projectUpdateNotifications or articleNotifications is available
        if (values.hasOwnProperty(PROJECT_UPDATE_NOTIFICATIONS) || values.hasOwnProperty(ARTICLE_NOTIFICATIONS)) {
          values = _objectSpread(_objectSpread({}, values), {}, {
            articleNotifications: _this.getNumericBooleanValue(values.articleNotifications),
            projectUpdateNotifications: _this.getNumericBooleanValue(values.projectUpdateNotifications)
          });
        }
        _this.props.updateProfile(values);
      });
    });
    return _this;
  }
  _inherits(ProfileForm, _Component);
  return _createClass(ProfileForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        profile = _this$props.profile,
        getRequest = _this$props.getRequest,
        getProfile = _this$props.getProfile,
        phase = _this$props.phase,
        invalidateProfile = _this$props.invalidateProfile;
      if (profile === undefined && getRequest && getRequest.networkStatus !== 'loading') {
        getProfile();
      }
      if (phase === 'cj2' && profile && profile.customer === null) {
        invalidateProfile();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        newPatchRequest = _this$props2.patchRequest,
        contactUrl = _this$props2.contactUrl,
        profile = _this$props2.profile,
        phase = _this$props2.phase,
        displaySuccessModal = _this$props2.displaySuccessModal;
      var loading = this.state.loading;
      var oldPatchRequest = prevProps.patchRequest;
      var oldNetworkStatus = oldPatchRequest && oldPatchRequest.networkStatus;
      var newNetworkStatus = newPatchRequest && newPatchRequest.networkStatus;
      if (oldNetworkStatus === 'loading' && loading) {
        if (newNetworkStatus === 'success') {
          this.setState({
            loading: false
          });
          var oldValues = this.getFormValues(prevProps);
          var newValues = this.getFormValues(this.props);
          var newValueArray = Object.keys(newValues).map(function (key) {
            return {
              key: key,
              value: newValues[key]
            };
          });
          var diffValues = newValueArray.filter(function (option) {
            return option.value !== oldValues[option.key];
          }).reduce(function (acc, curr) {
            acc[curr.key] = curr.value;
            return acc;
          }, {});
          var formCJ1WithValues = getFormCJ1(contactUrl, profile.email);
          var form = phase === 'cj1' ? formCJ1WithValues : profile.customer ? getFormCJ2(contactUrl, profile.customer).concat(formCJ1WithValues) : null;

          // When the user uploads an image, we dont show the modal that summarizes changes
          var diffKeys = Object.keys(diffValues).filter(function (key) {
            return key !== 'users' && key !== 'image' && key !== 'customerImage';
          });
          if (form && form.length > 0 && diffKeys.length > 0) {
            displaySuccessModal({
              type: 'editProfile',
              componentProps: {
                form: form,
                values: diffValues
              }
            });
          }
        }
        if (newNetworkStatus === 'failed') {
          var error;
          switch (get(newPatchRequest, 'errorBody.message')) {
            case 'Email-address already exists':
              error = 'Er bestaat al een account met dit emailadres.';
              break;
            default:
              error = 'Er is iets mis gegaan.';
              break;
          }
          this.setState({
            error: error,
            loading: false
          });
        }
      }
    }
  }, {
    key: "getProfileFormFields",
    value: function getProfileFormFields() {
      var _this$props3 = this.props,
        contactUrl = _this$props3.contactUrl,
        profile = _this$props3.profile,
        phase = _this$props3.phase;
      var formCJ1WithValues = getFormCJ1(contactUrl, profile.email);
      return phase === 'cj1' ? formCJ1WithValues : getFormCJ2(contactUrl, profile.customer).concat(formCJ1WithValues);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        match = _this$props4.match,
        profile = _this$props4.profile,
        phase = _this$props4.phase,
        contactUrl = _this$props4.contactUrl;
      var _this$state = this.state,
        error = _this$state.error,
        loading = _this$state.loading;
      return !isObjectEmpty(this.getFormValues({
        profile: profile,
        phase: phase,
        contactUrl: contactUrl
      })) ? __jsx(Container, {
        "data-e2e-profile-form": true,
        "data-id": "dashboard_ProfileForm_Container"
      }, __jsx(FormTitle, {
        "data-id": "dashboard_ProfileForm_FormTitle"
      }, "Profiel"), error && __jsx(FormError, {
        "data-id": "dashboard_ProfileForm_FormError"
      }, error), __jsx(FormGenerator, {
        fields: this.getProfileFormFields(),
        defaultValues: this.getFormValues({
          profile: profile,
          phase: phase,
          contactUrl: contactUrl
        }),
        submitLabel: "Profielinformatie updaten",
        loadingLabel: "aanpassingen worden verwerkt",
        submitFn: this.handleSubmit,
        loading: loading,
        "data-id": "dashboard_ProfileForm_FormGenerator"
      }), __jsx(FormFooter, {
        "data-id": "dashboard_ProfileForm_FormFooter"
      }, "We gebruiken de gegevens die je achterlaat om onze producten en diensten steeds beter te maken en jouw gebruikerservaring zo goed mogelijk af te stemmen op jouw profiel. In ons", ' ', __jsx(Link, {
        href: "/".concat(String(match.params.projectSlug), "/open/sectionpage/privacy-statement"),
        target: "_blank",
        rel: "noopener noreferrer",
        "data-id": "dashboard_ProfileForm_Link"
      }, "privacybeleid"), ' ', "lees je precies hoe we omgaan met de door jou opgegeven informatie"), profile.isAnonymizable && __jsx(ButtonPrimary, {
        type: "internalLink",
        label: "Verwijder mijn account",
        link: "".concat(String(match.params.projectSlug), "/closed/").concat(StaticPageSlugForProject['vergeet-mij']),
        buttonColor: colorPalette.red,
        "data-id": "dashboard_ProfileForm_ButtonPrimary"
      })) : null;
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(ProfileForm));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  opacity: 0;\n  animation: ", " 0.25s ease-in;\n  animation-fill-mode: forwards;\n  background-color: white;\n  order: 4;\n  width: calc(100% - 60rem);\n  padding: 40rem 30rem;\n\n  > form {\n    > div {\n      > h3 {\n        margin-top: 0rem;\n      }\n    }\n    .formfield_customerName {\n      padding-top: 5rem;\n    }\n    .formfield_familyMakeup h4 {\n      margin-bottom: 5rem;\n    }\n    .formfield_anonymous,\n    .formfield_contactInformation,\n    .formfield_image {\n      padding-top: 0;\n    }\n    .formfield_emailAddress p {\n      margin-bottom: 0;\n    }\n    .formfield_users {\n      ul {\n        margin-bottom: 15rem;\n      }\n      a {\n        font-weight: bold;\n        font-size: 18rem;\n      }\n    }\n    .formfield_projectupdate_subscribed {\n      padding-top: 0;\n    }\n  }\n\n  @media all and (max-width: 969px) {\n    margin-left: 0rem;\n  }\n\n  ", ";\n"])), fadeIn, toBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 32rem 15rem;\n    width: calc(100% - 30rem);\n  "]))));
var FormTitle = styled.h2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var FormError = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 20rem;\n  justify-content: center;\n  border: solid 1px #eee;\n  border-radius: 5rem;\n  background: ", ";\n  font-family: ", ";\n  color: red;\n  margin-bottom: 15rem;\n"])), colorPalette.lightGrey, fonts.primary);
var FormFooter = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  margin-top: 40rem;\n  margin-bottom: 20rem;\n  color: ", ";\n\n  > a {\n    color: ", ";\n    cursor: pointer;\n    text-decoration: none;\n    border-bottom: 1rem solid transparent;\n    transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n    &:hover {\n      color: ", ";\n      border-bottom: 1rem solid ", ";\n    }\n  }\n\n  ", ";\n"])), textStyles.caption, colorPalette.textGrey, colorPalette.blue, colorPalette.darkBlue, colorPalette.darkBlue, toBreakpoint.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: 12rem;\n    margin-top: 32rem;\n    margin-bottom: 10rem;\n  "]))));